/**
 * Auto-collapsing product description for Horizon Theme
 * Works even if description is auto-rendered
 */

document.addEventListener('DOMContentLoaded', () => {
  // Try common Horizon description containers
  const selectors = [
    '.product__description',
    '.product-description',
    '.product__details',
    '.rte',
    '[id*="ProductInfo"] .rte'
  ];

  let content;
  for (const sel of selectors) {
    const el = document.querySelector(sel);
    if (el && el.textContent.trim().length > 100) {
      content = el;
      break;
    }
  }

  if (!content) return;

  // Skip if it's already wrapped or too short
  if (content.scrollHeight < 400 || content.classList.contains('collapsible-description__inner')) return;

  // Wrap existing content
  const wrapper = document.createElement('div');
  wrapper.className = 'collapsible-description';

  const inner = document.createElement('div');
  inner.className = 'collapsible-description__inner';
  inner.id = 'collapsible-description-content';

  // Move description inside the inner wrapper
  content.parentNode.insertBefore(wrapper, content);
  inner.appendChild(content);
  wrapper.appendChild(inner);

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'collapsible-description__toggle';
  button.textContent = 'View more';
  button.setAttribute('aria-expanded', 'false');
  wrapper.appendChild(button);

  // Apply behavior
  button.addEventListener('click', () => {
    const expanded = inner.classList.toggle('expanded');
    button.textContent = expanded ? 'View less' : 'View more';
    button.setAttribute('aria-expanded', expanded);
  });

  // Hide toggle if not tall enough
  if (inner.scrollHeight <= 400) button.style.display = 'none';
});
